import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { StarredContentMenuQuery } from './queries/StarredContentMenuQuery.graphql';
import { starredContentMenuQueryVars } from './StarredContentMenu';

export function preloadStarredContentMenu() {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: StarredContentMenuQuery,
		variables: starredContentMenuQueryVars,
		fetchPolicy: 'network-only',
	});
}
